import { render, staticRenderFns } from "./migrate.vue?vue&type=template&id=3fd05e17&"
import script from "./migrate.vue?vue&type=script&lang=js&"
export * from "./migrate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports